import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useLang } from "@/context/LanguageContext";
import api, { formatApiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";

export default function ResetPassword() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password must be at least 6 characters.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t("new_password")}>
      {!token ? (
        <p className="text-sm text-red-600" data-testid="reset-no-token">Invalid or missing reset link.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <div>
            <Label htmlFor="password">{t("new_password")}</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" className="mt-1.5" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#8B1E2B] hover:bg-[#6f1622] text-white" data-testid="reset-submit-button">
            {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} {t("reset_password")}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
